<template>
  <div class="navbar">
    <div class="title">
      <div>
        <img class="logo" src="/static/user/img/app/logo.png"/>
        <span class="txt"> {{ title[module] }}</span>
      </div>
    </div>
    <div class="top">
      <div class="time">
        <img src="/static/user/img/app/clock.png" alt="">
        {{ time | parseTime("{y}-{m}-{d} {h}:{i}:{s}", "") }}
      </div>
      <div class="action">
        <img class="icon" src="/static/user/img/app/person.png" @click="detail()" alt="">
        <el-dropdown trigger="click" @command="jump">
          <span class="el-dropdown-link">
            <img class="icon" src="/static/user/img/app/switch.png" alt="">
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="expert">人才平台</el-dropdown-item>
            <el-dropdown-item command="enterprise">产业平台</el-dropdown-item>
            <el-dropdown-item command="policy">政策平台</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <img class="icon" src="/static/user/img/app/full-screen.png" @click="toggleFullScreen()" alt="">
        <img class="icon" src="/static/user/img/app/logout.png" @click="logout" alt="">
      </div>
    </div>
    <el-dialog
      title="个人信息"
      v-if="visible.detail"
      :visible.sync="visible.detail"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="400px"
      center>
      <el-form ref="detailForm" label-width="50px" size="mini">
        <el-form-item label="名称">{{ user.name }}</el-form-item>
        <el-form-item label="电话">{{ user.phone }}</el-form-item>
        <el-form-item label="邮箱">{{ user.email }}</el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  components: {},
  computed: {
    ...mapGetters([
      'user',
    ])
  },
  data() {
    return {
      visible: {detail: false},
      time: new Date(),
      module: "expert",
      title: {
        "expert": "川渝创新资源服务平台(人才)",
        "enterprise": "川渝创新资源服务平台(产业)",
        "enterprise-zs": "川渝中试服务平台",
        "policy": "川渝创新资源服务平台(政策)"
      }
    }
  },
  mounted() {
    this.switchRoute();
    setInterval(() => {
      this.time = new Date();
    }, 1000);
  },
  watch: {
    '$route'(to, from) {
      this.switchRoute();
    }
  },
  created() {
  },
  methods: {
    switchRoute() {
      console.log("switch route....")
      let module = this.$route.meta.module;
      let subModule = this.$route.query["sub"];
      if (subModule && subModule !== '') {
        module = module + "-" + subModule;
      }
      this.module = module;
    },
    detail() {
      this.visible.detail = true;
    },
    toggleFullScreen() {
      if (!document.fullscreenElement) {
        // 进入全屏
        document.documentElement.requestFullscreen();
      } else {
        // 退出全屏
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    },
    jump(command) {
      this.$router.push({"name": command});
    },
    logout() {
      this.$store.dispatch("sys/logout")
        .then(() => {
          this.$router.push("/");
        });
    },
  }
}
</script>
<style type="text/css">

</style>
<style lang="scss" scoped>
@import "@/styles/variables.scss";

.navbar {
  height: 20vh;
  background: url("/static/user/img/app/header_bg.png") no-repeat center;
  background-size: cover;
}

.title {
  > div {
    margin: auto;
    width: 40vw;
    min-width: 500px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    height: 6vh;
  }


  .logo {
    height: 90%
  }

  .txt {
    color: #FFFFFF;
    font-size: 3.8vh;
    font-family: "Microsoft YaHei", "微软雅黑", "Helvetica Neue", sans-serif;
    text-align: center;
    letter-spacing: 0.4vw;
    font-weight: bold;
    font-style: italic;
  }

}

.top {
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .time {
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 22px;
    letter-spacing: 1px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 200px;

    > img {
      height: 18px;
    }
  }


  .action {
    width: 110px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .icon {
      height: 18px;
      cursor: pointer;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/user/layout/components/Navbar.vue